var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCorneringEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Cornering Events",
    role: "img",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cornering Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,0c27.6142,0,50,22.3858,50,50s-22.3858,50-50,50S0,77.6142,0,50C0.0325,22.3992,22.3992,0.0325,50,0z  M50,92.633c23.5455,0,42.633-19.0874,42.633-42.633S73.5455,7.367,50,7.367S7.367,26.4545,7.367,50c0,0,0,0,0,0 C7.3914,73.5354,26.4646,92.6086,50,92.633z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,39.0964c6.0217,0,10.9032,4.8815,10.9032,10.9032S56.0217,60.9028,50,60.9028 s-10.9032-4.8815-10.9032-10.9032c0,0,0,0,0,0C39.105,43.9813,43.9817,39.1045,50,39.0964z M50,53.5358 c1.953,0,3.5362-1.5832,3.5362-3.5362S51.953,46.4634,50,46.4634s-3.5362,1.5832-3.5362,3.5362 C46.4679,51.9509,48.0488,53.5317,50,53.5358z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6835,95.167h-7.367V54.9357h7.367V95.167z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2684,50.0217L10.2696,30.3738l3.6835-6.3798l33.9988,19.6331L44.2684,50.0217z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2011,50.2651l-3.6835-6.3798l34.4335-19.891l3.6835,6.3798L55.2011,50.2651z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorneringEvents);
export default __webpack_public_path__ + "static/media/cornering-events.021a5a0163cbcaa13934bb491baedabf.svg";
export { ForwardRef as ReactComponent };